import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';
import componentStyles from './pc-testimonial.css.lit';
import { classMap } from 'lit/directives/class-map.js';

import '../pc-container/pc-container';
import globalStyles from './pc-testimonial.lightDom.css.lit';

/**
 * Testimonial component
 * @element pc-testimonial
 * @slot - This element has a default slot
 */
@customElement('pc-testimonial')
export class PCTestimonial extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];
  adoptedStylesheets: AdoptedStyleSheets;

  @property({ type: Boolean, attribute: 'is-reversed' })
  isReversed = false;

  hasImage = false;

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
    this.hasImage = Boolean(this.querySelector('[slot="image"]'));
  }

  render(): TemplateResult {
    const classes = {
      'testimonial': true,
      'without-image': !this.hasImage,
      'is-reversed': this.isReversed,
    };

    return html`
      <div class=${classMap(classes)}>
        <div class="container">
          <div class="content">
            <slot name="nav"></slot>

            <blockquote class="quote">
              <slot name="content"></slot>
              <footer>
                <slot name="footer"></slot>
                <div class="image--mobile">
                  <slot name="image-mobile"></slot>
                </div>
              </footer>
            </blockquote>

            <div class="image">
              <slot name="image"></slot>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-testimonial': PCTestimonial;
  }
}
